module.exports = __webpack_public_path__ + "img/download-2-INTphone.b4b1431a.png";